(function () {
  'use strict';

  if (window.__nuceryMcsAddInit) return;
  window.__nuceryMcsAddInit = true;

  function addUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      return window.theme.routes.cartAdd;
    }
    // Locale/market-aware: Shopify Markets prefixes routes (e.g. /en-sa/), so a bare /cart/add.js 404s.
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
  }

  function onAddClick(e) {
    var btn = e.target.closest && e.target.closest('[data-mcs-add-to-cart]');
    if (!btn || btn.disabled || btn.getAttribute('data-mcs-adding') === '1') {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) {
      return;
    }
    btn.setAttribute('data-mcs-adding', '1');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('mobile-circle-slider__link--loading');
    var formData = new FormData();
    formData.append('id', String(id));
    formData.append('quantity', '1');
    fetch(addUrl(), {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        } else {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product: data, addToCartBtn: btn },
            })
          );
        }
      })
      .catch(function () {
        var url = btn.getAttribute('data-product-url');
        if (url) {
          window.location.href = url;
        }
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('data-mcs-adding');
        btn.disabled = false;
        btn.classList.remove('mobile-circle-slider__link--loading');
      });
  }

  document.addEventListener('click', onAddClick, true);
})();
